import ShPopConfirm from '@/components/Helpers/ShPopConfirm';
import PopoverSmsGateway from '@/components/Sms/PopoverSmsGateway';

// @vue/component
export default {
  name: 'SmsIncomingListItem',

  components: {
    ShPopConfirm,
    PopoverSmsGateway
  },

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    projectsList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      agentNote: '',
      visibleNotePopover: false,
    };
  },
  watch: {
    item: {
      handler() {
        this.agentNote = this.item.agent_note;
      },
      deep: true,
    }
  },

  computed: {
    isSmsGatewayVisible() {
      return this.item.from_number.length === 11
            && this.item.from_number.slice(0, 2) === '48';
    },
  },
  methods: {
    async updateNote() {
      if(this.agentNote === null) this.agentNote = '';
      await this.$store.dispatch('sms/updateNote', {
        sms_uuid: this.item.sms_uuid,
        agent_note: this.agentNote,
      });
      this.$emit('fetchData');
      this.visibleNotePopover = false;
    },
    async deleteSms() {
      await this.$store.dispatch('sms/deleteSmsFromIncoming', {
        sms_uuid: this.item.sms_uuid,
      });
      this.$emit('fetchData');
    },
    closePopover() {
      this.agentNote = this.item.agent_note;
      this.visibleNotePopover = false;
    }
  },
  created() {
    this.agentNote = this.item.agent_note;
  }
}
